import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const cardStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1.25rem 1.5rem;
	border-radius: ${theme.radii.xlarge};
	border: 1px solid ${theme.colors.border};
	background-color: ${theme.colors.surface};
`;

const headerStyle = css`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	justify-content: space-between;
	gap: 0.75rem;
`;

const titleStyle = css`
	${theme.typography.cardTitle}
	margin: 0;
	color: ${theme.colors.ink};
`;

const textStyle = css`
	margin: 0.25rem 0 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

const actionsStyle = css`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.75rem;
`;

type Props = {
	readonly title: string;
	readonly subtitle: string;
	readonly actions?: React.ReactNode;
	/** Explanatory line under the list. */
	readonly hint?: string | null;
	readonly children: React.ReactNode;
};

/** The card that frames the list of a tab: title, subtitle, actions on the right, the list, then a hint. */
const CostCard: React.FC<Props> = ({ title, subtitle, actions, hint = null, children }) => {
	return (
		<section css={cardStyle} aria-label={title}>
			<div css={headerStyle}>
				<div>
					<h3 css={titleStyle}>{title}</h3>
					<p css={textStyle}>{subtitle}</p>
				</div>
				<div css={actionsStyle}>{actions}</div>
			</div>
			{children}
			<ConditionalLoader data={hint}>{(text) => <p css={textStyle}>{text}</p>}</ConditionalLoader>
		</section>
	);
};

export default CostCard;
